import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { PageHeader, Section, StatusBadge, Empty, RowLink } from "../components/common";
import { fmtDate, money } from "../lib/helpers";

const FILTERS = [["", "All", "Todos"], ["pending_signature", "Waiting for signature", "Esperando firma"], ["signed", "Signed", "Firmados"]];

export default function Contracts() {
  const { t, lang } = useLang();
  const [status, setStatus] = useState("");
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/contracts", { params: { status } }).then((r) => setList(r.data)); }, [status]);
  return (
    <>
      <PageHeader title={t("Contracts", "Contratos")} subtitle={t("Create contracts from an approved estimate.", "Cree contratos desde un presupuesto aprobado.")} />
      <div className="flex gap-2 overflow-x-auto mb-4">
        {FILTERS.map(([k, en, es]) => (
          <button key={k} onClick={() => setStatus(k)} data-testid={`contracts-filter-${k || "all"}`} className={`btn-sm btn shrink-0 ${status === k ? "bg-slate-900 text-white" : "bg-white border border-slate-300"}`}>{lang === "es" ? es : en}</button>
        ))}
      </div>
      <Section testid="contracts-list">
        {list && !list.length && <Empty text={t("No contracts", "Sin contratos")} />}
        {list?.map((k) => (
          <RowLink key={k.id} to={`/contracts/${k.id}`} testid={`contract-row-${k.id}`}>
            <span className="mono text-sm font-semibold w-16">{k.number}</span>
            <div className="flex-1 min-w-0"><div className="font-semibold truncate">{k.customer_name}</div><div className="text-xs text-slate-500">{fmtDate(k.date, lang)}</div></div>
            {k.contract_price != null && <span className="mono text-sm hidden sm:block">{money(k.contract_price)}</span>}
            <StatusBadge status={k.status} />
          </RowLink>
        ))}
      </Section>
    </>
  );
}
